/**
 * Calculates the percentage which the partial is of the total to X decimals
 *
 * @param {number} total - Max value possible
 * @param {number} partial - Currently used amount
 * @param {number} [decimals = 0] - How many decimals to round to, defaults to 0
 * @returns Rounded percentage number
 */
export function calculatePercentage(total, partial, decimals = 0) {
    const factor = Math.pow(10, decimals);
    const percentage = (partial / total) * 100;
    return Math.round(percentage * factor) / factor;
}
